import React from 'react';
import { Button } from './Shared';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    root: {
        color: '#ffffff !important',
        alignItems: 'center !important',
        fontFamily: "Light",
        padding: theme.spacing(1),
    },
    opacity: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)!important'
    },
    paperScrollPaper: {
        alignItems: 'center',
        backgroundColor: '#131313',
        border: '1px solid #555353',
        boxShadow: '0 2px 6px rgba(0, 172, 193, 0.3)',
        direction: "unset"
    },
    openDialog: {
        opacity: 0.0018,
    },
    icon: {
        width: '20px',
        height: '20px'
    },
    resieIcon:{
        width:'69px',
        height:'43px'
    }    
}));

const AlertDialog = ({ bodyTxt, btnTxt, urlLink,DialogIcon }) => {
    const [open, setOpen] = React.useState(true);
    const classes = useStyles();

    return (
        <div className="openDialog">
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{
                    paperScrollPaper: classes.paperScrollPaper,
                    root: classes.opacity
                }}
            >
                <DialogTitle>
                    <DialogIcon className={`${!!btnTxt ? classes.icon : classes.resieIcon}`} />
                </DialogTitle>
                <DialogContent
                    classes={{
                        root: classes.root
                    }}
                >
                    <DialogContentText
                        id="alert-dialog-description"
                        classes={{
                            root: classes.root
                        }}
                    >
                        {bodyTxt}
                    </DialogContentText>
                </DialogContent>
                {!!btnTxt && <DialogActions>
                    <Button to={urlLink} className="btn">
                        {btnTxt}
                    </Button>
                </DialogActions>}
            </Dialog>
        </div>
    );
}


export default AlertDialog;